import Button from '~/shared/components/ButtonsV2';
import Typography from '~/shared/components/Typography';
import BoltIcon from '~/shared/assets/icons/bolt.svg';
import backgroundLines from '~/shared/assets/images/background-lines.png';
import autoscaleRulesImage from '~/shared/assets/images/create-autoscale-rule-image.png';
import Guard from '~/shared/components/Guard';

interface AutoscaleRulesEmptyStateProps {
  onCreateRule: () => void;
  isOrganizationAccount?: boolean;
}

export default function AutoscaleRulesEmptyState({
  onCreateRule,
  isOrganizationAccount = false,
}: AutoscaleRulesEmptyStateProps) {
  return (
    <div className="ag-overlay-no-rows-wrapper flex flex-col h-full items-center justify-center gap-2 0 relative">
      <div
        className="absolute inset-0 bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${backgroundLines})`,
          backgroundSize: '800px',
          maskImage:
            'radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 20%, rgba(0,0,0,0) 40%)',
          WebkitMaskImage:
            'radial-gradient(circle, rgba(0,0,0,1) 0%, rgba(0,0,0,0.8) 25%, rgba(0,0,0,0) 40%)',
        }}
      />
      <div className="flex flex-col items-center gap-1.5 md:gap-2 relative z-10">
        <img
          className="ml-0 xl:ml-10 z-10 h-auto w-48 xl:w-72 2xl:w-[389px]"
          src={autoscaleRulesImage}
          alt="Autoscale Rules"
        />
        <div className="flex flex-col items-center gap-1 md:gap-1.5 xl:gap-2">
          <Typography
            variant="H3-med-resp"
            fontWeight={600}
            color="text-gray-900 font-family-outfit"
            className=""
          >
            Create your first AutoScale rule
          </Typography>
          <Typography
            variant="p2"
            color="text-gray-700"
            className="text-center max-w-xs md:max-w-md font-family-inter text-xs md:text-sm xl:text-base"
          >
            Manage your volumes usage automatically
          </Typography>
        </div>
      </div>
      <Guard permission="datafy.write.autoscaling.rules">
        <Button
          className="flex gap-1.5 md:gap-2 items-center relative z-10"
          leftIcon={<BoltIcon className="size-3.5 md:size-4 xl:size-5 aspect-square stroke-white" />}
          onClick={onCreateRule}
          size="md"
          disabled={isOrganizationAccount}
        >
          <Typography variant="p3-resp" color="" className="text-xs md:text-sm xl:text-base">
            Create a rule
          </Typography>
        </Button>
      </Guard>
    </div>
  );
}
